module.exports = __webpack_public_path__ + "media/invite/impersonate-e49fbaf3.svg";